import React, { useEffect } from "react";
import { TextField, Grid, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CompanyVeiwController from "../../../redux/actions/companyApiActions";

const EmployerInformationForm = ({ formik }) => {
  const { values, errors, touched, handleChange, handleBlur } = formik;
  const dispatch = useDispatch();
  const { getCompanies } = CompanyVeiwController();
  const { companies } = useSelector((state) => state.company);

  useEffect(() => {
    dispatch(getCompanies());
  }, [dispatch]);

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="First Name"
          name="first_name"
          value={values.first_name}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={touched.first_name && Boolean(errors.first_name)}
          helperText={touched.first_name && errors.first_name}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Last Name"
          name="last_name"
          value={values.last_name}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={touched.last_name && Boolean(errors.last_name)}
          helperText={touched.last_name && errors.last_name}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.email && Boolean(errors.email)}
          helperText={touched.email && errors.email}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Contact Number"
          name="mobile_number"
          value={values.mobile_number}
          onChange={handleChange}
          onBlur={handleBlur}
          inputProps={{ maxLength: 10, inputMode: "numeric" }}
          error={touched.mobile_number && Boolean(errors.mobile_number)}
          helperText={touched.mobile_number && errors.mobile_number}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          select
          fullWidth
          label="Company"
          name="company"
          value={values.company}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={touched.company && Boolean(errors.company)}
          helperText={touched.company && errors.company}
        >
          <MenuItem value="">Select Company</MenuItem>
          {companies.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.company_name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};

export default EmployerInformationForm;
